import { SectionCard } from '../SectionCard'
import { Skeleton } from '../ui/skeleton'

export function DepartmentItemsSkeleton({ count = 1 }: { count?: number }) {
  return (
    <SectionCard headerClass="pb-0" header={<Skeleton className="h-3 w-40 mb-4" />}>
      <div className="flex flex-col gap-2">
        {Array.from({ length: count }).map((_, i) => (
          <Skeleton key={i} className="h-5 w-full" />
        ))}
      </div>
    </SectionCard>
  )
}
